import { render } from "./DashboardsYearFilterBlock.vue?vue&type=template&id=7a601140&scoped=true&ts=true"
import script from "./DashboardsYearFilterBlock.vue?vue&type=script&lang=ts"
export * from "./DashboardsYearFilterBlock.vue?vue&type=script&lang=ts"

import "./DashboardsYearFilterBlock.vue?vue&type=style&index=0&id=7a601140&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a601140"]])

export default __exports__